import { PropSharingListing, WithInquiry } from '@guiker/propsharing-shared'

export const isListingWithInquiry = <T extends PropSharingListing>(listing: T): listing is WithInquiry<T> => {
  return !!(listing as WithInquiry<PropSharingListing>).fractionalOwnershipInquiry
}
